// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3af2O","list":"PatternAutocomplete_list__6P2ox"};